<script lang="ts">
  import classNames from 'classnames';

  export let hasBackground: boolean = false;
  export let transparent: boolean = false;
  export let hasWhole: boolean = false;
  export let isRed: boolean = false;
  export let isBlack: boolean = false;
  export let progress: number;

  const classes = classNames('content-section', {
    ['background']: hasBackground,
    ['whole']: hasWhole,
    ['transparent']: transparent,
    ['red']: isRed,
    ['black']: isBlack,
  });
</script>

<section class="{`${$$props.class ?? ''} ${classes} ${progress}`}">
  <slot />
</section>

<style type="text/scss">
  @import '../../styles/styles.scss';
  .content-section {
    width: 100vw;
    min-height: 100vh;
    height: 100%;
    padding: 25px;
    display: grid;
    justify-items: center;
    align-items: center;
    position: relative;
  }

  .background {
    background-color: #ffe7d3;
    min-height: 50vh;
    height: 100%;
    transition: all 1.5s ease;

    &.transparent {
      background-color: rgba(193, 2, 31, 0);
    }

    &.red {
      background-color: rgba(193, 2, 31);

      &.true {
        background-color: rgba(193, 2, 31, 0);
      }
    }

    &.black {
      background-color: rgba(0, 0, 0);

      &.true {
        background-color: rgba(0, 0, 0, 0);
      }
    }
  }

  .first {
    background: rgb(193,2,31);
    background: linear-gradient(180deg, rgba(193,2,31,1) 0%, rgba(0,0,0,1) 100%);
    padding: 24px;
    overflow-y: auto;
    max-height: 50vh;

    div {
      width: 100%;
    }
  }

  .content-section.whole {
    position: relative;
    overflow: hidden;
  }

  .content-section.whole:before {
    content: '';
    position: absolute;
    top: 30%;
    width: 200%;
    height: 150%;
    border-radius: 45%;
    box-shadow: 0px 100px 200px 1000px #ffe7d3;
  }

  @media screen and (min-width: 1028px) {
    .first {
      padding: 80px;
      max-height: 100vh;
    }

    .background {
      min-height: 100vh;
    }

    .content-section.whole:before {
      top: 15%;
      width: 75%;
    }
  }
</style>
